import React from 'react'
import {
  Button,
  FormDashboardLabel as Label,
  ImagePickerSidebar,
  VisibilitySelector,
  SelectCheckbox,
  ButtonOutline,
  TagAdder
} from '../../../components'
import { useHistory } from 'react-router-dom'

const Sidebar = () => {
  const history = useHistory()
  const [form, setForm] = React.useState({visibility: 'public'})

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div>
      <div className="hidden lg:block p-5 rounded mb-8" style={{background: '#f5f5f5'}}>
        <p className="text-sm text-gray-444 mb-4">
          Status: <strong>Approved</strong>
        </p>
        <Button className="mb-3" onClick={() => history.push('/dashboard/resources')}>Submit</Button>
        <ButtonOutline
          transparent
          outlineColor="primary"
          className="text-primary uppercase font-accent py-4"
          onClick={() => history.push('/dashboard/resources')}
        >
          Save to Draft
        </ButtonOutline>
      </div>
      <div className="mb-5 lg:mb-10">
        <ImagePickerSidebar label="Cover Image"/>
      </div>
      <div className="mb-5 lg:mb-10">
        <div className="mb-5 lg:mb-0">
          <Label>Visibility</Label>
        </div>
        <VisibilitySelector form={form} updateForm={updateForm} />
      </div>
      <div className="mb-5 lg:mb-10">
        <Label>Suitable For</Label>
        <SelectCheckbox className="text-sm" placeholder="Choose"/>
      </div>
      <div className="mb-8 lg:mb-10">
        <Label>Tag</Label>
        <TagAdder />
      </div>
      {/* <div className="mb-5 lg:mb-10">
        <Label>Categories</Label>
        <div className="pt-3">
          <div className="flex flex-wrap -mx-2">
            <div className="w-1/2 lg:w-full px-2 lg:px-0">
              <Checkbox className="mb-2" id="checkbox1" label="Research" defaultChecked={true}/>
              <Checkbox className="mb-2" id="checkbox2" label="Essai"/>
              <Checkbox className="mb-2" id="checkbox3" label="Zine"/>
            </div>
            <div className="w-1/2 lg:w-full px-2 lg:px-0">
              <Checkbox className="mb-2" id="checkbox4" label="Comic" defaultChecked={true}/>
              <Checkbox className="mb-2" id="checkbox5" label="News"/>
              <Checkbox className="mb-3" id="checkbox6" label="Poem"/>
            </div>
          </div>
        </div>
      </div> */}
      <div className="lg:hidden mb-10">
        <Button thin className="mb-3" onClick={() => history.push('/dashboard/resources')}>Submit</Button>
        <ButtonOutline
          transparent
          outlineColor="primary"
          className="text-primary uppercase font-accent"
          onClick={() => history.push('/dashboard/resources')}
        >
          Save to Draft
        </ButtonOutline>
      </div>
    </div>
  )
}

export { Sidebar }